module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 20
// module chunks = 0